<template>
  <v-container grid-list-lg class="pa-0">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-layout row align-end>
        <v-flex xs4 sm3>
          <v-text-field
            label="Nome"
            v-model="data.name"
            :rules="validate.requiredRules"
            required
            :disabled="isDisplayMode"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm3>
          <v-text-field
            label="Descrição"
            v-model="data.description"
            :rules="validate.requiredRules"
            :disabled="isDisplayMode"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm4>
          <v-combobox
            allow-overflow
            item-text="name"
            item-value="id"
            :rules="validate.multipleRules"
            v-model="data.templates"
            :items="templates"
            label="Templates"
            :disabled="isDisplayMode"
            multiple
            chips
          ></v-combobox>
        </v-flex>
        <v-flex xs2 sm2 align-self-center v-if="!isDisplayMode">
          <slot />
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
export default {
  name: 'CostCenterItems',
  props: {
    data: {
      type: Object,
      required: true
    },
    displayMode: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isDisplayMode: null,
      valid: true,
      templates: [
        {
          id: 123,
          name: 'Template 1'
        },
        {
          id: 12223,
          name: 'Template 2'
        },
        {
          id: 45123,
          name: 'Template 3'
        },
        {
          id: 56123,
          name: 'Template 4'
        }
      ]
    }
  },
  mounted () {
    this.isDisplayMode = this.displayMode
  },
  methods: {
    validation () {
      return this.$refs.form.validate()
    }
  },
  watch: {
    displayMode (value) {
      this.isDisplayMode = value
    }
  }
}
</script>

